import { Transition } from '@headlessui/react';
import { memo, useMemo, useRef } from 'react';
import { TrackType } from '@goldcast/player-config/src/types/Track/Type';
import { LottieElement } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Element/LottieElement';
import LottieElementRemoveButton from './LottieElementRemoveButton';
import LottieElementFill from './LottieElementFill';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

function LottieElementMenu({ lottieElementId }: { lottieElementId: string }) {
  const menuRef = useRef<HTMLDivElement>(null);
  const { clipData } = useClipsContext();

  const selectedElement = useMemo(() => {
    return clipData.asset_metadata.player_config?.playerConfig.tracks
      ?.filter(track => track.type === TrackType.ELEMENTS)
      ?.flatMap(track => track.elements)
      ?.find(element => element.id === lottieElementId) as LottieElement;
  }, [clipData.asset_metadata.player_config?.playerConfig.tracks, lottieElementId]);

  return (
    <Transition
      appear
      as="div"
      show
      className="z-[60] flex cursor-auto items-center justify-center transition-all duration-100"
      enterFrom="opacity-0 max-h-0"
      enterTo="opacity-100 max-h-96"
      leaveFrom="opacity-100 max-h-96"
      leaveTo="opacity-0 max-h-0"
    >
      <div
        id="lottie-element-menu"
        className="relative flex space-x-1 rounded-lg border bg-white p-0.5 shadow"
        onPointerDown={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
        ref={menuRef}
      >
        <div className="relative z-10">
          <LottieElementFill selectedElement={selectedElement} />
        </div>
        <div className="relative z-10">
          <LottieElementRemoveButton lottieElementId={lottieElementId} />
        </div>
      </div>
    </Transition>
  );
}

export default memo(LottieElementMenu);
